// This is so the button height is correctly calculated in som-popover
som-button {
  display: inline-block;
}

.chevron-icon {
  margin-left: .5rem;
}